// extracted by mini-css-extract-plugin
module.exports = {"Footer":"styles_Footer__1BUlg"};